var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [
        _vm._v("Content from playlist")
      ]),
      _c("playlist-selector", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.source.type === "playlist",
            expression: 'source.type === "playlist"'
          }
        ],
        attrs: {
          id: "playlist-selector",
          justPublicStatus: true,
          showRequiredError:
            _vm.formSubmitted && _vm.validations.playlist.$invalid
        },
        model: {
          value: _vm.source.playlist,
          callback: function($$v) {
            _vm.$set(_vm.source, "playlist", $$v)
          },
          expression: "source.playlist"
        }
      }),
      _vm.source.type && _vm.source.type !== "playlist"
        ? _c(
            "md-layout",
            {
              staticClass: "additional-settings",
              attrs: { "md-column": "md-column" }
            },
            [
              _c("div", { staticClass: "md-subheading" }, [
                _vm._v("Source Settings")
              ]),
              _c(
                "md-layout",
                { attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50" } },
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", [_vm._v("Playlist Length")]),
                          _c(
                            "md-select",
                            {
                              on: { selected: _vm.getVideosInDistribution },
                              model: {
                                value: _vm.source.params.length,
                                callback: function($$v) {
                                  _vm.$set(_vm.source.params, "length", $$v)
                                },
                                expression: "source.params.length"
                              }
                            },
                            [
                              _c("md-option", { attrs: { value: 1 } }, [
                                _vm._v("1")
                              ]),
                              _c("md-option", { attrs: { value: 5 } }, [
                                _vm._v("5")
                              ]),
                              _c("md-option", { attrs: { value: 10 } }, [
                                _vm._v("10")
                              ]),
                              _c("md-option", { attrs: { value: 15 } }, [
                                _vm._v("15")
                              ]),
                              _c("md-option", { attrs: { value: 20 } }, [
                                _vm._v("20")
                              ]),
                              _c("md-option", { attrs: { value: 25 } }, [
                                _vm._v("25")
                              ]),
                              _c("md-option", { attrs: { value: 30 } }, [
                                _vm._v("30")
                              ]),
                              _c("md-option", { attrs: { value: 40 } }, [
                                _vm._v("40")
                              ]),
                              _c("md-option", { attrs: { value: 50 } }, [
                                _vm._v("50")
                              ]),
                              _c("md-option", { attrs: { value: 100 } }, [
                                _vm._v("100")
                              ]),
                              _c("md-option", { attrs: { value: 500 } }, [
                                _vm._v("500")
                              ]),
                              _c("md-option", { attrs: { value: 1000 } }, [
                                _vm._v("1000")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50" } },
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", [_vm._v("Playlist Sort")]),
                          _c(
                            "md-select",
                            {
                              on: { selected: _vm.getVideosInDistribution },
                              model: {
                                value: _vm.source.params.sort,
                                callback: function($$v) {
                                  _vm.$set(_vm.source.params, "sort", $$v)
                                },
                                expression: "source.params.sort"
                              }
                            },
                            [
                              _c(
                                "md-option",
                                {
                                  attrs: {
                                    value: { by: "lastUpdated", order: "desc" }
                                  }
                                },
                                [_vm._v("Newest")]
                              ),
                              _c(
                                "md-option",
                                {
                                  attrs: {
                                    value: { by: "lastUpdated", order: "asc" }
                                  }
                                },
                                [_vm._v("Oldest")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("md-chips", {
                attrs: {
                  "md-max": 10,
                  "md-input-placeholder": "Keywords Blocking..."
                },
                on: { change: _vm.getVideosInDistribution },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(chip) {
                        return [_c("span", [_vm._v(_vm._s(chip.value))])]
                      }
                    }
                  ],
                  null,
                  false,
                  3226392169
                ),
                model: {
                  value: _vm.source.params.keywordsBlocking,
                  callback: function($$v) {
                    _vm.$set(_vm.source.params, "keywordsBlocking", $$v)
                  },
                  expression: "source.params.keywordsBlocking"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "loader",
        { attrs: { loading: _vm.loadingVideos, size: 40 } },
        [
          _c("distribution-arranged-list", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.source.playlist || _vm.source.network,
                expression: "source.playlist || source.network"
              }
            ],
            staticClass: "video-list",
            attrs: {
              videos: _vm.videosInDistribution,
              containsInvalidItems: _vm.containsInvalidItems,
              label: "Videos in this distribution",
              "allow-delete": _vm.source.type === "playlist",
              deletingItem: _vm.deletingItem
            },
            on: {
              removeItem: _vm.onItemRemoved,
              customData: _vm.onSetCustomData
            }
          })
        ],
        1
      ),
      _c(
        "md-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.source.playlist || _vm.source.network,
              expression: "source.playlist || source.network"
            }
          ]
        },
        [
          _c(
            "md-button",
            { staticClass: "md-button", on: { click: _vm.resetSort } },
            [_vm._v("Reset Sort")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5670f7ec", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5670f7ec","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/ContentForm.vue
// module id = 752
// module chunks = 0